

export function getEmptySerial(): any
{
		throw new Error('Method not implemented.');
}
